import { render } from "./Setting.vue?vue&type=template&id=79ea425e&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=79ea425e&scoped=true&lang=css"
import "./Setting.vue?vue&type=style&index=1&id=79ea425e&lang=css"
import "./Setting.vue?vue&type=style&index=2&id=79ea425e&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ea425e"]])

export default __exports__